import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiLayTatCaApp(payload) {
    return HTTP({
        url: ENDPOINT.APP.ALL,
        method: "GET",
        params: payload
    });
}

export function callApiLayDanhSachAppPaging(payload) {
    return HTTP({
        url: ENDPOINT.APP.SEARCH,
        method: "GET",
        params: payload
    });
}

export function callApiThemMoiApp(payload) {
    return HTTP({
        url: ENDPOINT.APP.ADD,
        method: "POST",
        data: payload
    });
}

export function callApiCapNhatApp(payload) {
    return HTTP({
        url: ENDPOINT.APP.UPDATE,
        method: "PUT",
        data: payload
    });
}

export function callApiCapNhatTrangThaiApp(payload) {
    return HTTP({
        url: ENDPOINT.APP.UPDATE_STATUS,
        method: "PUT",
        data: payload
    });
}

export function callApiXoaApp(payload) {
    return HTTP({
        url: ENDPOINT.APP.DELETE,
        method: "DELETE",
        params: payload
    });
}

export function callApiCapNhatThuTu(payload) {
    return HTTP({
      url: ENDPOINT.APP.UPDATE_STATUS,
      method: "PUT",
      data: payload
    });
  }

export function callApiGetListApp(payload) {
  return HTTP({
    url: ENDPOINT.APP.LIST_APP,
    method: "GET",
    data: payload
  });
}
